import { render } from "./CustomerStory.vue?vue&type=template&id=f18866ba"
import script from "./CustomerStory.vue?vue&type=script&lang=js"
export * from "./CustomerStory.vue?vue&type=script&lang=js"

import "./CustomerStory.vue?vue&type=style&index=0&id=f18866ba&lang=scss"

import exportComponent from "/home/runner/work/intelli-landing-frontend/intelli-landing-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__